import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { AccordionSummary, Accordion, AccordionDetails, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import QuizCard from "../../components/QuizCard/quizCard";
import { useSelectedExam } from "examsbook-react-sdk/custom-hooks";
import { toggleSavedQuiz } from "examsbook-react-sdk/actions";
import { useDispatch } from 'react-redux';

/**
 * TestAccordion compoment.
 * @param props
 * @returns {*}
 * @constructor
 */
function TestAccordion(props) {
    const navigate = useNavigate();
    const { quizGroup, lang, singleTestSeriesLoading } = props;
    const selectedExam = useSelectedExam();
    const [ open, setOpen ] = useState(false);
    const dispatch = useDispatch();

    function handleChange() {
        setOpen(!open);
    }

    function unSaveQuiz(quiz) {
        dispatch(toggleSavedQuiz(quiz._id));
    }

    return (
        <div>
            {selectedExam ?
                (quizGroup && quizGroup.quizes && quizGroup.quizes.length ?
                    <Accordion className="accordion analysis-component"
                               expanded={!open}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon/>} onClick={handleChange}
                                          aria-controls="panel1a-content" id="panel1a-header">
                            <Typography>
                                {quizGroup.section[lang]}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className="Accordian-detail">
                            {
                                (quizGroup.quizes).map((quiz) => {
                                    return (
                                        <QuizCard quizData={quiz} key={quiz._id}
                                                  singleTestSeriesLoading={singleTestSeriesLoading}
                                                  toggleQuizSave={() => unSaveQuiz(quiz)}/>
                                    );
                                })
                            }
                        </AccordionDetails>
                    </Accordion> : <QuizCard singleTestSeriesLoading={singleTestSeriesLoading}/>) :
                navigate("/my-app/test-series") //<Navigate to="/my-app/test-series"/>
            }
        </div>
    );
}

export default TestAccordion;
